import fetcher from 'api/fetcher';

export const endSudoSession = (): void => {
    void fetcher.delete('/api/v1/session/sudo').then(() => {
        window.location.href = '/new/admin/users/';
    });
};
